import React from 'react'
import RightSide from '../components/common/rightSide';


const ProcessingFees = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        {/* <JournalDetails /> */}
                    </div>

                </div>
            </div>
        </>
    )
}

export default ProcessingFees;